import firebase from 'firebase'
import 'firebase/functions'

export default firebase.initializeApp({
  apiKey: "AIzaSyA7FyG8j3-ygWOTJs6uifn1FZESzEa23xg",
  authDomain: "upgasvntrx-b26c8.firebaseapp.com",
  databaseURL: "https://upgasvntrx-b26c8.firebaseio.com",
  projectId: "upgasvntrx-b26c8",
  storageBucket: "upgasvntrx-b26c8.appspot.com",
  messagingSenderId: "654682157999"
})
